import { useState, useEffect, createRef, useRef } from "react";
import { GridStack } from "gridstack";
import PublicChat from "src/components/widgets/PublicChat";
import NetworkEffect from "src/pachinko/NetworkEffect";



const Item = ({ id, onRemove }) => <div className="z-20 card bg-gray-800 bg-opacity-50 h-full border-2 transition-colors duration-300 border-blue-500
         overflow-hidden">{id} <button onClick={(e) => onRemove(id)}>remove</button></div>;

//
// Controlled example
//
const ControlledStack = ({ items, addItem, onRemove }) => {
  const refs = useRef({});
  const gridRef = useRef();

 

  if (Object.keys(refs.current).length !== items.length) {
    items.forEach(({ id }) => {
      refs.current[id] = refs.current[id] || createRef();
    });
  }

  useEffect(() => {
    gridRef.current =
      gridRef.current ||
      GridStack.init({ float: true, removable: "#trash" }, ".controlled");
    const grid = gridRef.current;
    grid.batchUpdate();
    grid.removeAll(false);
    items.forEach(({ id }) => grid.makeWidget(refs.current[id].current));
    grid.batchUpdate(false);
  }, [items]);

  return (
    <div>
      <div
        id="trash"
        style={{
          padding: "8px",
          backgroundColor: "red",
          height: "3rem",
          width: "3rem",
        }}
      >
        Trash
      </div>
      <button onClick={addItem}>Add new widget</button>
      <button onClick={() => {
        gridRef.current.column(6);
      }}>CHANGE COLS</button>
      <div className={`grid-stack controlled`}>
        {items.map((item, i) => {
          return (
            <div
              ref={refs.current[item.id]}
              key={item.id}
              className={"grid-stack-item"}
            >
              <div className="grid-stack-item-content">
                <Item id={item.id} onRemove={onRemove} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const TestPage = () => {
    const itemSet1 = [{ id: "item-1" }, { id: "item-2" }];
    const itemSet2 = [{ id: "item-2" }, { id: "item-3" }, { id: "item-4" },{ id: "item-a" }, { id: "item-3v" }, { id: "item-d" },{ id: "item-z" }, { id: "item-x" }, { id: "item-q" },{ id: "item-t" }, { id: "item-f" }, { id: "item-fda" }];
    
    // Use a single state to store all item sets as keys with arrays as values
    const [itemSets, setItemSets] = useState({
      1: itemSet1,
      2: itemSet2,
    });
    const [currentSet, setCurrentSet] = useState(1);
  
    const handleRemove = (id) => {
        console.log(id);
      // Update the set by filtering out the removed item
      setItemSets(prev => {
        const updatedSet = prev[currentSet].filter((item) => item.id !== id);
        console.log(itemSets);
        return { ...prev, [currentSet]: updatedSet };
      });
    };
  
    const switchSet = (setNumber) => {
      setCurrentSet(setNumber); // Switch to the selected set
    };

     const contRef = useRef();
  
    return (
      <>
      <button onClick={() => {

      }}>TEST COLUMNN CHANGE</button>
        <div ref={contRef} className="p-1 relative rounded-xl z-0 bg-gradient-to-r from-pink-500 via-purple-500 to-indigo-500 bg-[length:200%] animate-gradient-x shadow-[0_0_80px_rgba(168,85,247,0.6)] opacity-100 h-[1000px] w-[1400px]">
          {/* <div className="absolute top-1 left-1 w-full h-full z-1">
              <NetworkEffect containerRef={contRef} />
            </div> */}
          <div>
            <ControlledStack items={itemSet2} onRemove={()=>{}}/>
          </div>
        </div>
      </>
    );
  };
export default TestPage;

